import { render, staticRenderFns } from "./intentionList.vue?vue&type=template&id=7e36d80a&scoped=true"
import script from "./intentionList.vue?vue&type=script&lang=js"
export * from "./intentionList.vue?vue&type=script&lang=js"
import style0 from "./intentionList.vue?vue&type=style&index=0&id=7e36d80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e36d80a",
  null
  
)

export default component.exports